import { render, staticRenderFns } from "./ShippingAddFormPricetable.vue?vue&type=template&id=17959744"
import script from "./ShippingAddFormPricetable.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormPricetable.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddFormPricetable.vue?vue&type=style&index=0&id=17959744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports